module.exports = __webpack_public_path__ + "static/media/bulb-icon.51ca3e8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/bulb-icon.svg
// module id = 386
// module chunks = 25